import React from "react";
import userImg from "../../images/user.png";
import "../../Styles/yellowcalf.css/Header.css";

const Header = () => {
  return (
    <header className="hdr-topbar">
      <div className="hdr-left"></div>
      <div className="hdr-right">
        <ul className="hdr-tools-list">
          <li>
            <select
              id="hdr-language-select"
              className="hdr-language-select"
              onChange={(e) => (window.location.href = e.target.value)}
            >
              <option value="/site/language?lang=en" defaultValue>
                English
              </option>
              <option value="/site/language?lang=ar">Arabic</option>
              <option value="/site/language?lang=pt">Portuguese</option>
              <option value="/site/language?lang=sp">Spanish</option>
            </select>
          </li>
          <li className="hdr-current-user">
            <img
              src={userImg}
              alt="User"
              className="hdr-user-img"
            />
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
